import {gql} from '@apollo/client';

export const CREATE_DINAMYCS = gql`
  mutation Mutation(
    $description: String!
    $finalDate: String!
    $mimeType: String!
    $nameimg: String!
    $receipt: String!
    $initialDate: String!
    $name: String!
    $palopoints: Float!
    $quarterId: Float!
    $typeActivity: Float!
  ) {
    CreateDinamycs(
      description: $description
      finalDate: $finalDate
      mime_type: $mimeType
      nameimg: $nameimg
      receipt: $receipt
      initialDate: $initialDate
      name: $name
      palopoints: $palopoints
      quarterId: $quarterId
      typeActivity: $typeActivity
    ) {
      message
    }
  }
`;
export const UPDATE_DINAMYCS = gql`
  mutation Mutation(
    $description: String!
    $finalDate: String!
    $mimeType: String!
    $nameimg: String!
    $receipt: String!
    $initialDate: String!
    $name: String!
    $palopoints: Float!
    $quarterId: Float!
    $typeActivity: Float!
    $activityId: Float!
  ) {
    UpdateDinamycs(
      description: $description
      finalDate: $finalDate
      mime_type: $mimeType
      nameimg: $nameimg
      receipt: $receipt
      initialDate: $initialDate
      name: $name
      palopoints: $palopoints
      quarterId: $quarterId
      typeActivity: $typeActivity
      activityID: $activityId
    ) {
      message
    }
  }
`;
export const VALIDATE_EVIDENCE = gql`
  mutation Mutation(
    $approved: Boolean!
    $evidenceId: Float!
    $reason: String!
  ) {
    ValidateEvidence(
      approved: $approved
      evidenceID: $evidenceId
      reason: $reason
    ) {
      message
    }
  }
`;

export const DELETE_HOLIDAY = gql`
  mutation DeleteHoliday($date: String!, $year: Int!, $country: String!) {
    deleteHoliday(date: $date, year: $year, country: $country) {
      year
    }
  }
`;

export const ADD_HOLIDAY = gql`
  mutation RegisterHoliday(
    $date: String!
    $year: Int!
    $country: String!
    $description: String!
  ) {
    registerHoliday(
      date: $date
      year: $year
      country: $country
      description: $description
    ) {
      year
    }
  }
`;

export const DELETE_INABILITY = gql`
  mutation DeleteInability($country: String!, $leaveType: String!) {
    deleteInability(country: $country, leaveType: $leaveType) {
      numberOfDays
    }
  }
`;

export const ADD_INABILITY = gql`
  mutation UpdateInabilityConfiguration(
    $id: Int!
    $days: Int!
    $status: CountryInabilityConfigurationStatus!
    $inabilityTypeName: String!
  ) {
    updateInabilityConfiguration(
      id: $id
      days: $days
      status: $status
      inabilityTypeName: $inabilityTypeName
    ) {
      id
      country
      days
      status
      inabilityType {
        id
        name
        description
      }
    }
  }
`;

export const CREATE_NEW_INABILITY = gql`
  mutation Mutation($inabilityName: String!, $country: String!, $days: Int!) {
    createInabilityConfiguration(
      inabilityName: $inabilityName
      country: $country
      days: $days
    ) {
      id
      country
      createdAt
      days
      status
      inabilityType {
        description
        id
        name
        type
      }
    }
  }
`;

export const DELETE_VACATION_RULE = gql`
  mutation DeleteVacationRule($yearThreshold: Float!, $country: String!) {
    deleteVacationRule(yearThreshold: $yearThreshold, country: $country) {
      timeInService
      vacationDays
    }
  }
`;

export const ADD_VACATION_RULE = gql`
  mutation AddVacationRule(
    $yearThreshold: Float!
    $country: String!
    $days: Float!
  ) {
    addVacationRule(
      yearThreshold: $yearThreshold
      country: $country
      days: $days
    ) {
      timeInService
    }
  }
`;

/**
 * Creates a future vacation regulation with explicit seniority ranges.
 */
export const CREATE_VACATION_REGULATION = gql`
  mutation CreateVacationRegulation(
    $country: String!
    $effectiveFrom: String!
    $vacationRanges: [VacationRegulationRangeInput!]!
  ) {
    createVacationRegulation(
      country: $country
      effectiveFrom: $effectiveFrom
      vacationRanges: $vacationRanges
    ) {
      id
      country
      effectiveFrom
      effectiveTo
      isCurrent
      isEditable
      vacationRanges {
        fromYear
        toYear
        vacationDays
      }
    }
  }
`;

/**
 * Updates a scheduled vacation regulation before it becomes active.
 */
export const UPDATE_VACATION_REGULATION = gql`
  mutation UpdateVacationRegulation(
    $id: Int!
    $effectiveFrom: String!
    $vacationRanges: [VacationRegulationRangeInput!]!
  ) {
    updateVacationRegulation(
      id: $id
      effectiveFrom: $effectiveFrom
      vacationRanges: $vacationRanges
    ) {
      id
      country
      effectiveFrom
      effectiveTo
      isCurrent
      isEditable
      vacationRanges {
        fromYear
        toYear
        vacationDays
      }
    }
  }
`;

/**
 * Deletes a scheduled vacation regulation before it becomes active.
 */
export const DELETE_VACATION_REGULATION = gql`
  mutation DeleteVacationRegulation($id: Int!) {
    deleteVacationRegulation(id: $id)
  }
`;

export const UPDATE_INABILITY = gql`
  mutation UpdateInabilityConfiguration(
    $id: Int!
    $days: Int!
    $status: CountryInabilityConfigurationStatus!
    $inabilityTypeName: String!
  ) {
    updateInabilityConfiguration(
      id: $id
      days: $days
      status: $status
      inabilityTypeName: $inabilityTypeName
    ) {
      id
      country
      days
      status
      inabilityType {
        name
        description
      }
    }
  }
`;

export const CREATE_MONETIZATION_CONFIGURATION = gql`
  mutation CreateMonetizationConfiguration(
    $country: String!
    $days: Float!
    $status: CountryAbsenceeConfigStatus
  ) {
    createMonetizationConfiguration(
      country: $country
      days: $days
      status: $status
    ) {
      id
      country
      leaveType {
        id
        name
        description
      }
      days
      status
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_MONETIZATION_CONFIGURATION = gql`
  mutation UpdateMonetizationConfiguration(
    $id: Int!
    $days: Float!
    $status: CountryAbsenceeConfigStatus!
  ) {
    updateMonetizationConfiguration(id: $id, days: $days, status: $status) {
      id
      country
      leaveType {
        id
        name
        description
      }
      days
      status
      createdAt
      updatedAt
    }
  }
`;
